import React, { useState, useEffect } from "react";
import { Card, Row, Col, Table, Alert } from "react-bootstrap";
import { formatNumber } from "../../../redux/utils";
import TaxItem from "../contractor-schedule/TaxItem";

const CapitalProjectTaxSection = ({ 
  form, 
  taxesList, 
  taxesApplied, 
  setTaxesApplied, 
  taxesLoading 
}) => {
  const [totalTaxAmount, setTotalTaxAmount] = useState(0);
  const [netAmount, setNetAmount] = useState(0);

  // Calculate totals when taxes change
  useEffect(() => {
    const taxTotal = taxesApplied.reduce((sum, tax) => sum + parseFloat(tax.amount || 0), 0);
    setTotalTaxAmount(taxTotal);
    setNetAmount(parseFloat(form.amount || 0) - taxTotal);
  }, [taxesApplied, form.amount]);

  return (
    <Card body className="my-3">
      {/* <h6 className="mb-3">Capital Project Tax Configuration</h6>
      
      <Alert variant="info" className="mb-3">
        <small>
          <strong>Capital Project PV Structure:</strong><br/>
          • Main PV: Contains narration, gross amount, tax summary, and net amount<br/>
          • Tax PVs: Separate PV created for each selected tax<br/>
          • All PVs are linked together for complete audit trail
        </small>
      </Alert> */}

      {taxesLoading ? (
        <div className="text-center py-3">
          <div className="spinner-border spinner-border-sm me-2" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          Loading taxes...
        </div>
      ) : (
        <>
          <h6 className="mb-2">Select Applicable Taxes:</h6>
          <Row>
            {taxesList.map((item, index) => (
              <TaxItem
                key={index}
                index={index}
                item={item}
                form={form}
                taxesApplied={taxesApplied}
                setTaxesApplied={setTaxesApplied}
              />
            ))}
          </Row>

          {taxesApplied.length > 0 && (
            <div className="mt-4">
              <h6>Tax Summary</h6>
              <Table bordered striped size="sm">
                <thead className="table-light">
                  <tr>
                    <th>Tax Name</th>
                    <th>Rate (%)</th>
                    <th className="text-end">Amount (₦)</th>
                  </tr>
                </thead>
                <tbody>
                  {taxesApplied.map((tax, index) => (
                    <tr key={index}>
                      <td>{tax.description}</td>
                      <td className="text-center">{tax.rate || 'N/A'}</td>
                      <td className="text-end">{formatNumber(tax.amount)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="table-secondary">
                  <tr>
                    <th colSpan="2">Total Taxes</th>
                    <th className="text-end">{formatNumber(totalTaxAmount)}</th>
                  </tr>
                </tfoot>
              </Table>

              <Card className="mt-3 border-success">
                <Card.Body className="bg-light">
                  <Row>
                    <Col md={4}>
                      <strong>Gross Amount:</strong><br/>
                      <span className="h5 text-primary">₦{formatNumber(form.amount || 0)}</span>
                    </Col>
                    <Col md={4}>
                      <strong>Total Taxes:</strong><br/>
                      <span className="h5 text-warning">₦{formatNumber(totalTaxAmount)}</span>
                    </Col>
                    <Col md={4}>
                      <strong>Net Amount:</strong><br/>
                      <span className="h5 text-success">₦{formatNumber(netAmount)}</span>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <Alert variant="success" className="mt-3">
                <small>
                  <strong>PVs to be created:</strong><br/>
                  • 1 Main PV (₦{formatNumber(netAmount)} - Net Amount)<br/>
                  {taxesApplied.map((tax, index) => (
                    <span key={index}>
                      • 1 Tax PV for {tax.description} (₦{formatNumber(tax.amount)})<br/>
                    </span>
                  ))}
                  <strong>Total: {1 + taxesApplied.length} PVs</strong>
                </small>
              </Alert>
            </div>
          )}
        </>
      )}
    </Card>
  );
};

export default CapitalProjectTaxSection;